import React from 'react';

function Footer() {
  return (
    <div className="p-10 text-gray-500 text-center">
      created by <strong>corbinrobb</strong> - devChallenges.io
    </div>
  );
}

export default Footer;
